import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import React from 'react';
import discount from 'configs/discount_plan.json';
import lodash from 'lodash';

const DiscountPackageService: React.FC = () => {
    const planKeys = lodash.get(discount, 'plan_detail_keys', []);
    const monthData = lodash.get(discount, 'month', {
        label: '',
        detail: {},
    });
    const monthDataDetail: Record<string, { text: string }> = lodash.get(
        monthData,
        'detail',
        {}
    );
    const yearData = lodash.get(discount, 'year', { label: '', detail: {} });
    const yearDataDetail: Record<string, { text: string }> = lodash.get(
        yearData,
        'detail',
        {}
    );
    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={{
                    boxShadow: 'none',
                    border: 'none',
                }}
            >
                <Table sx={{ borderCollapse: 'collapse' }}>
                    <TableHead
                        sx={{
                            backgroundColor: 'var(--color-primary-lighter)',
                        }}
                    >
                        {['Gói dịch vụ'].map((item, index) => (
                            <TableCell
                                key={`static-${index}`}
                                align={'left'}
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {item}
                            </TableCell>
                        ))}
                        {planKeys.map((item, index) => (
                            <TableCell
                                key={`header-${index}`}
                                align={'left'}
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {lodash.get(discount, `${item}.label`, '')}
                            </TableCell>
                        ))}
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {monthData.label}
                            </TableCell>
                            {planKeys.map((planKey: string, index) => (
                                <TableCell
                                    key={`month-${planKey}`}
                                    sx={{
                                        border: 'none',
                                        fontWeight: index === 0 ? 600 : 'unset',
                                        fontSize: '18px',
                                        lineHeight: '21.78px',
                                    }}
                                >
                                    {
                                        monthDataDetail[
                                            planKey as keyof typeof monthDataDetail
                                        ].text
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            <TableCell
                                sx={{
                                    border: 'none',
                                    fontWeight: 600,
                                    fontSize: '18px',
                                    lineHeight: '21.78px',
                                }}
                            >
                                {yearData.label}
                            </TableCell>
                            {planKeys.map((planKey: string, index) => (
                                <TableCell
                                    key={`year-${planKey}`}
                                    sx={{
                                        border: 'none',
                                        fontWeight: index === 0 ? 600 : 'unset',
                                        fontSize: '18px',
                                        lineHeight: '21.78px',
                                    }}
                                >
                                    {
                                        yearDataDetail[
                                            planKey as keyof typeof monthDataDetail
                                        ].text
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default DiscountPackageService;
